import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function PublishLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/publisher/logs?limit=200").then((r) => setItems(r.data.items)); }, []);
  return (
    <div className="p-8 md:p-10">
      <div className="overline text-[#B4533C]">Publish Log</div>
      <h1 className="font-serif text-4xl mt-1 mb-6">Activity</h1>
      <div className="border border-[#D6CFC4]">
        <table className="w-full admin-table">
          <thead className="bg-[#EFECE5]"><tr><th className="p-3 text-left">Time</th><th className="p-3 text-left">Article</th><th className="p-3 text-left">Actor</th><th className="p-3 text-left">Action</th><th className="p-3 text-left">Reason</th></tr></thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className="border-t border-[#D6CFC4]">
                <td className="p-3 font-mono text-xs">{new Date(l.created_at).toLocaleString()}</td>
                <td className="p-3 text-xs">{l.article_id}</td>
                <td className="p-3 text-xs">{l.actor}</td>
                <td className="p-3 text-xs font-mono">{l.action}</td>
                <td className="p-3 text-xs">{l.reason || "—"}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-sm text-[#4A4742]">No activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
